import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "-my-3.5 divide-y divide-[#eef0f3]" }
const _hoisted_2 = {
  key: 0,
  "data-no-stores": "",
  class: "text-sm text-gray-500"
}
const _hoisted_3 = { class: "-my-3.5" }
const _hoisted_4 = {
  key: 0,
  class: "rounded-lg bg-amber-50 px-4 py-3 text-sm text-amber-800"
}
const _hoisted_5 = { class: "text-sm font-medium text-gray-700" }

import { computed } from 'vue'

import SelectInput from '@/components/neue/SelectInput.vue'
import HighlightedText from '@/components/neue/wizard/HighlightedText'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import ToggleRow from '@/components/neue/wizard/ToggleRow.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import {
  customersOf,
  joiningOptions,
  sectionCopy,
  startingTierHelp,
  tierLabel,
  upgradeNote
} from '@/config/membershipTierWizardSteps'
import { startingTierWarning } from '@/helpers/membershipTierWizardSummary'


export default {
  __name: 'StepJoining',
  props: {
  stores: { type: Array, default: () => [] },
  storesKnown: { type: Boolean, default: true },
  currentDefault: { type: Object, default: null },
  tiers: { type: Array, default: () => [] },
  editingId: { type: String, default: null }
},
  setup(__props) {

const JOINING_ICONS = { checkout: 'store', invite: 'invite' }

const props = __props

const wizard = injectWizard()
const joining = computed(() => wizard.data.joining)

const options = computed(() => joiningOptions(wizard.data))
const starting = computed(() => sectionCopy('starting', wizard.data))
const startingLabel = computed(() => `Start new customers on ${tierLabel(wizard.data)}`)
const startingHelp = computed(() => startingTierHelp(wizard.data, props.currentDefault))
const startingWarning = computed(() =>
  startingTierWarning(wizard.data, { stores: props.stores, currentDefault: props.currentDefault })
)

const customers = computed(() => customersOf(wizard.data))
const upgradeLabel = computed(() => {
  const text = `${customers.value} can upgrade to`
  return text.charAt(0).toUpperCase() + text.slice(1)
})
const downgradeLabel = computed(() => `When ${customers.value} downgrade, they drop back to`)
const upgradeChoices = computed(() => props.tiers.filter(tier => tier.id !== joining.value.downgradeTierId))
const downgradeOptions = computed(() => [
  { name: 'No membership picked', value: null },
  ...props.tiers
    .filter(tier => !joining.value.upgradeTierIds.includes(tier.id))
    .map(tier => ({ name: tier.name, value: tier.id }))
])

const toggleIn = (ids, id) => (ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id])

const toggleStore = id => {
  joining.value.storeIds = toggleIn(joining.value.storeIds, id)
}

const toggleUpgrade = id => {
  joining.value.upgradeTierIds = toggleIn(joining.value.upgradeTierIds, id)
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('joining', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(SelectionGroup, {
          label: _unref(sectionCopy)('joining', _unref(wizard).data).title
        }, {
          default: _withCtx(({ groupName }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
              return (_openBlock(), _createBlock(SelectionCard, {
                key: option.value,
                name: groupName,
                icon: JOINING_ICONS[option.value],
                title: option.title,
                subtitle: option.subtitle,
                selected: joining.value.mode === option.value,
                onSelect: $event => (joining.value.mode = option.value)
              }, null, 8, ["name", "icon", "title", "subtitle", "selected", "onSelect"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 16),
    (joining.value.mode === 'checkout')
      ? (_openBlock(), _createBlock(WizardSection, _normalizeProps(_mergeProps({ key: 0 }, _unref(sectionCopy)('stores', _unref(wizard).data))), {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stores, (store) => {
                return (_openBlock(), _createBlock(ToggleRow, {
                  key: store.id,
                  title: store.name,
                  "model-value": joining.value.storeIds.includes(store.id),
                  "onUpdate:modelValue": $event => (toggleStore(store.id))
                }, null, 8, ["title", "model-value", "onUpdate:modelValue"]))
              }), 128))
            ]),
            (__props.storesKnown && !__props.stores.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Create a store first, then come back to offer this membership at checkout. "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true),
    (joining.value.mode)
      ? (_openBlock(), _createBlock(WizardSection, {
          key: 1,
          title: starting.value.title,
          description: startingHelp.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(ToggleRow, {
                modelValue: joining.value.isDefault,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((joining.value.isDefault) = $event)),
                title: startingLabel.value
              }, null, 8, ["modelValue", "title"])
            ]),
            (startingWarning.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  _createVNode(_unref(HighlightedText), { text: startingWarning.value }, null, 8, ["text"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "description"]))
      : _createCommentVNode("", true),
    (__props.tiers.length)
      ? (_openBlock(), _createBlock(WizardSection, _mergeProps({ key: 2 }, _unref(sectionCopy)('upgrades', _unref(wizard).data), { plain: "" }), {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_5, [
              _createVNode(_unref(HighlightedText), { text: upgradeLabel.value }, null, 8, ["text"])
            ]),
            (upgradeChoices.value.length)
              ? (_openBlock(), _createBlock(SelectionGroup, {
                  key: 0,
                  label: upgradeLabel.value,
                  mode: "check"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(upgradeChoices.value, (tier) => {
                      return (_openBlock(), _createBlock(SelectionCard, {
                        key: tier.id,
                        mode: "check",
                        compact: "",
                        title: tier.name,
                        subtitle: _unref(upgradeNote)(_unref(wizard).data, tier, __props.tiers, __props.editingId),
                        selected: joining.value.upgradeTierIds.includes(tier.id),
                        onSelect: $event => (toggleUpgrade(tier.id))
                      }, null, 8, ["title", "subtitle", "selected", "onSelect"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(SelectInput, {
              "model-value": joining.value.downgradeTierId,
              name: downgradeLabel.value,
              options: downgradeOptions.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (joining.value.downgradeTierId = $event))
            }, null, 8, ["model-value", "name", "options"])
          ]),
          _: 1
        }, 16))
      : _createCommentVNode("", true)
  ], 64))
}
}

}